import Edit from 'govbr.frontend.policy/components/Blocks/Video/Edit';

export default Edit;
